import React, { FC } from 'react'
import s from './OurTeam.module.scss'
import { BACKEND_URL } from '../../../api'
import parse from 'html-react-parser'

interface OurTeamProps {
    description?: string;
    image?: {
        src: string | null;
        type: string;
    };
}

const OurTeam: FC<OurTeamProps> = ({ description, image }) => {
    const imageSrc = image?.src ? (image.src.startsWith('http') ? image.src : BACKEND_URL + image.src) : null;

    return (
        <section className={`${s.section}`}>
            <div className={`${s.container} container`}>
            {imageSrc && image && (
                <div className={s.img}>
                    {image.type === 'video' ? (
                        <video src={imageSrc} autoPlay muted loop playsInline />
                    ) : (
                        <img src={imageSrc} alt="about_us" />
                    )}
                </div>
            )}
            {description && <p className={s.text}>{description}</p>}
            </div>
            <div className={`${s.shapeRight}`} />
            <span className={`${s.gradientLine} lineGradient bottom-line`} />
        </section>
    )
}

export default OurTeam